// extracted by mini-css-extract-plugin
export default {"subscribeBox":"subscribeBox-o4ISS3dTnnHXeDkUIrWt"};